import { render, staticRenderFns } from "./form-item.vue?vue&type=template&id=7c9b2c3a&scoped=true"
import script from "./form-item.vue?vue&type=script&lang=js"
export * from "./form-item.vue?vue&type=script&lang=js"
import style0 from "./form-item.vue?vue&type=style&index=0&id=7c9b2c3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9b2c3a",
  null
  
)

export default component.exports